var map = {
	"./activity.js": 23001,
	"./addressBook.js": 279175,
	"./aiChat.js": 258244,
	"./aiNoteTask.js": 901887,
	"./cloudDocument.js": 579334,
	"./comment.js": 900071,
	"./common.js": 633441,
	"./consult.js": 590254,
	"./find.js": 572427,
	"./globalSearch.js": 296327,
	"./irmEmbed.js": 752751,
	"./irmworkbench.js": 432567,
	"./manage.js": 179607,
	"./materialRedirect.js": 356469,
	"./meeting.js": 327,
	"./memberZone.js": 184156,
	"./news.js": 496107,
	"./openClaw.js": 726183,
	"./preprocessingPage.js": 960935,
	"./publicOpinion.js": 135863,
	"./question.js": 236752,
	"./reportManage.js": 702357,
	"./researchMode.js": 844310,
	"./roadshow.js": 195411,
	"./schedule.js": 52617,
	"./summary.js": 994394,
	"./survey.js": 758646,
	"./testIrm.js": 1320,
	"./thirdparty.js": 905235,
	"./thoughtChain.js": 586010,
	"./translation.js": 585313,
	"./voice.js": 929600,
	"./workbench.js": 311583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 344243;